export default __webpack_public_path__ + "static/media/wa-logo-footer.5991d5db.svg";